import resetPassword from './Index';

export default [
  {
    path: '/resetpassword',
    name: 'resetpassword',
    component: resetPassword,
    props: false
  }
];